"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryAttributeByDisplayFormService = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var queryService_1 = require("../store/_infra/queryService");
var effects_1 = require("redux-saga/effects");
var general_1 = require("../events/general");
var store_1 = require("../store");
exports.QueryAttributeByDisplayFormService = queryService_1.createCachedQueryService("GDC.DASH/QUERY.DISPLAY.FORM.ATTRIBUTE", queryService, function (query) {
    var displayForms = query.payload.displayForms;
    return displayForms.map(function (df) { return sdk_model_1.serializeObjRef(df); }).join();
});
/**
 * Loads the attribute metadata for given display form. Primarily the metadata are loaded
 * from the catalog attributes. If the required attribute is not listed in the catalog
 * (e.g. deprecated attributes), the attribute metadata are fetched from the backend.
 */
function loadAttributeByDisplayForm(ctx, catalogAttributes, displayForm) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var backend, workspace, attribute;
        return tslib_1.__generator(this, function (_a) {
            backend = ctx.backend, workspace = ctx.workspace;
            attribute = catalogAttributes.find(function (catalogAttribute) {
                return catalogAttribute.displayForms.some(function (df) { return sdk_model_1.areObjRefsEqual(df, displayForm); });
            });
            if (attribute) {
                return [2 /*return*/, attribute.attribute];
            }
            return [2 /*return*/, backend.workspace(workspace).attributes().getAttributeByDisplayForm(displayForm)];
        });
    });
}
function loadAttributes(ctx, catalogAttributes, displayForms) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, Promise.all(displayForms.map(function (df) { return loadAttributeByDisplayForm(ctx, catalogAttributes, df); }))];
        });
    });
}
function queryService(ctx, query) {
    var displayForms, correlationId, catalogAttributes, attributes;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                displayForms = query.payload.displayForms, correlationId = query.correlationId;
                return [4 /*yield*/, effects_1.select(store_1.selectCatalogAttributes)];
            case 1:
                catalogAttributes = _a.sent();
                return [4 /*yield*/, effects_1.call(loadAttributes, ctx, catalogAttributes, displayForms)];
            case 2:
                attributes = _a.sent();
                if (!attributes) {
                    throw general_1.invalidQueryArguments(ctx, "Cannot find attribute for given displayForm", correlationId);
                }
                return [2 /*return*/, attributes];
        }
    });
}
//# sourceMappingURL=queryAttributeByDisplayForm.js.map